// extracted by mini-css-extract-plugin
module.exports = {"required":"Label_required__2czki","root":"Label_root__2qFNc"};